<template>
  <div class="import-final-result-dialog">
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_ImportFinalResult')"
      width="530px"
      @close="innerVisible=false"
    >
      <div class="app-main-inner-row">
        <span style="font-size:14px;padding-left:15px;">{{ '【' }}<a style="color:blue" @click="onViewClick">{{ this.filingBatchNo }}</a>{{ '】' + this.$t('CargoMsg.Cargo_SureToImportFinalResult') }}</span>
      </div>
      <div class="app-main-inner-row" style="padding-left:0px;padding-top:35px;">
        <el-upload
          ref="importPrice"
          :action="URL.price.openPrice.importFinalResultExcel"
          :headers="{ sessionId }"
          :show-file-list="false"
          :multiple="false"
          :auto-upload="false"
          accept=".xls,.xlsx"
          :before-upload="beforeUpload"
          :on-success="uploadExcelSuccess"
          :on-error="uploadExcelError"
          :data="{ filingBatchNo: this.filingBatchNo || '' }"
          :on-progress="uploadProcess"
          :on-change="handleChange"
          style="display:inline-block;margin-left:5px; margin-right:5px"
        >
          <el-button type="primary" no="selectFile">{{ $t('SeaExport.SelectFile') }}</el-button>
        </el-upload>
        <el-input v-model="txtFileName" no="txtFileName" style="font-size:13px;padding-right:5px;" class="fileNameClass" :readonly="true" />
        <p><a style="font-size:13px;color:blue;" @click="removeFile">X</a></p>
      </div>
      <div slot="footer">
        <el-button no="cancel" @click="innerVisible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button type="primary" no="confirm" :disabled="txtFileName===''" @click="importExcelHandler">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import URL from '@/api/urlTranslator'

export default {
  name: 'ImportFinalResultDialog',
  props: {
    visible: { type: Boolean, required: true },
    batchUuid: { type: String, default: '' },
    filingBatchNo: { type: String, default: '' } // 备案批次号
  },
  data() {
    return {
      URL,
      loading: false,
      innerVisible: false,
      txtFileName: '' // 导入文件名
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.txtFileName = ''
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.txtFileName = ''
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  methods: {
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('Information.TheOnlyBeXlsFormat'))
      }
      if ((Math.round(file.size * 100 / (1024 * 1024)) / 100) > 10) {
        this.$message.warning(this.$t('CargoMsg.FileBeLargerThan10MB'))
        return false
      }
      return extension || extension2
    },
    uploadExcelSuccess(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        this.onImportSucceeded(response.data)
      } else {
        this.$message.error(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    onImportSucceeded(data) {
      if (data.message) {
        this.$confirm(data.message, this.$t('Message.Error2'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_ConfirmR'),
          showCancelButton: false,
          type: 'error'
        }).then(() => {
          this.innerVisible = false
        }).catch(() => {})
      } else {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
        this.innerVisible = false
        this.$emit('importSuccess')
      }
    },
    uploadExcelError(err) {
      this.loading.close()
    },
    uploadProcess() {
      this.loading = getLoading()
    },
    handleChange(file) {
      this.txtFileName = file.name || ''
    },
    removeFile() {
      this.txtFileName = ''
      this.$refs.importPrice.uploadFiles = []
    },
    importExcelHandler() {
      if (!this.txtFileName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectFile'))
        return false
      }
      this.loading = getLoading()
      const uploadFiles = this.$refs.importPrice.uploadFiles
      if (uploadFiles && uploadFiles.length > 0) {
        setTimeout(() => {
          this.$refs.importPrice.submit()
        }, 1000)
      }
    },
    onViewClick() {
      this.$emit('viewClick', this.batchUuid)
    }
  }
}
</script>

<style lang="scss">
.fileNameClass {
  .el-input__inner {
    color: blue !important;
  }
}
</style>
